import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2, ViewChild, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AccountV2ViewComponentDef } from '@df/account/v2/view/account-v2-view.component.def';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { LineSeparatorComponent } from '../../common/line-separator/line-separator.component';
import { AccountNavigationComponent } from '../navigation/account-navigation.component';
import { NAccountViewCms } from './account-view-cms.component';

export interface IAccountRouteData {
    contentCols?: number;
    fullPage?: boolean;
}

@Component({
    selector: 'account-view',
    templateUrl: './account-view.html',
    styleUrls: ['./account-view.scss'],
    standalone: true,
    imports: [
        SizeClassDirective,
        DfUiModule,
        TranslationModule,
        LineSeparatorComponent,
        AccountNavigationComponent,
        NgClass,
        RouterOutlet,
        ICmsClientModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountViewComponent extends AccountV2ViewComponentDef {
    protected contentCols = 8;
    protected fullPage = false;

    protected asyncCd = false;

    private renderer2 = inject(Renderer2);
    private elementRef = inject(ElementRef);

    @Input()
    content?: NAccountViewCms.IBlockDataContent;

    @ViewChild(RouterOutlet, { static: true })
    outlet: RouterOutlet;

    ngOnInit(): void {
        super.ngOnInit();
        this.outlet.activateEvents.subscribe(d => {
            const data = this.outlet.activatedRouteData as IAccountRouteData;
            const fullPage = !!data?.fullPage;
            const contentCols = fullPage ? 12 : (data?.contentCols as number) || 8;
            const changed = this.contentCols !== contentCols || this.fullPage !== fullPage;
            if (changed) {
                this.contentCols = fullPage ? 12 : contentCols;
                this.fullPage = fullPage;
                this.detectChanges();
            }
        });
    }
}
